import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {SessionService} from './session.service';
import {Match} from '../model/events/Match';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class PerformanceService
{

  constructor(private http: HttpClient,
              private sessionService: SessionService)
  {

  }

  getPerformancesForEvent(tournamentSerieId: number, eventId: number): Observable<any[]>
  {
    let url;
    if (tournamentSerieId && tournamentSerieId > 0)
      url = this.sessionService.baseUrlApi + 'performance/tournamentserie/' + tournamentSerieId;
    if (eventId && eventId > 0)
      url = this.sessionService.baseUrlApi + 'performance/event/' + eventId;

    console.log('HTTP GET: ' + url);
    return this.http.get<any[]>(url);
  }

  savePerformanceForEvent(performance: any, tournamentSerieId: number, eventId: number): Observable<any>
  {
    let url;
    if (tournamentSerieId && tournamentSerieId > 0)
      url = this.sessionService.baseUrlApi + 'performance/tournamentserie/' + tournamentSerieId;
    if (eventId && eventId > 0)
      url = this.sessionService.baseUrlApi + 'performance/event/' + eventId;

    console.log('HTTP POST: ' + url);
    return this.http.post<any>(url, performance);
  }

  deletePerformance(id: number): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + 'performance/' + id;
    console.log('HTTP DELETE: ' + url);
    return this.http.delete<any>(url);
  }

  getPerformancPlayerForEvent(eventId: number): Observable<any[]>
  {
    const url = this.sessionService.baseUrlApi + 'performance/event/' + eventId + '/performancePlayer';
    console.log('HTTP GET: ' + url);
    return this.http.get<any[]>(url);
  }
  getPerformancesForMatch(eventId: number, match: Match, participantId: number): Observable<any[]>
  {
    let url: string;
    if (match?.matchReport)
      url = this.sessionService.baseUrlApi + 'performance/event/' + eventId + '/match/' + match.id + '?matchReport=1';
    else if (participantId > 0)
      url = this.sessionService.baseUrlApi + 'performance/participant/' + participantId;
    else url = this.sessionService.baseUrlApi + 'performance/event/' + eventId + '/match/' + match?.id;

    /*const url = participantId > 0 ?
      (this.sessionService.baseUrlApi + 'performance/participant/' + participantId) :
      (this.sessionService.baseUrlApi + 'performance/match/' + match?.id);*/
    console.log('HTTP GET: ' + url);
    return this.http.get<any[]>(url);
  }
  deletePerformancePlayer(id: number): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + 'performance/player/' + id;
    console.log('HTTP DELETE: ' + url);
    return this.http.delete<any>(url);
  }
  savePerformancePlayer(body: any, eventId: number): Observable<any>
  {
    for (const performance of body)
    {
      performance.eventId = eventId;
    }
    const url = this.sessionService.baseUrlApi + 'performance/player';
    console.log('HTTP POST: ' + url, body);
    return this.http.post<any>(url, body);
  }
  updatePerformancePlayerCount(body: any): Observable<any>
  {
    const url = this.sessionService.baseUrlApi + 'performance/player/count';
    console.log('HTTP POST: ' + url, body);
    return this.http.post<any>(url, body);
  }

  getPerformanceRequirementsForEvent(eventId: number, matchId: number, participantId: number): Observable<any>
  {
    const url = matchId > 0 ?
      (this.sessionService.baseUrlApi + 'performance/requirements/' + eventId + '/match/' + matchId) :
      (this.sessionService.baseUrlApi + 'performance/requirements/' + eventId + '/participant/' + participantId);
    console.log('HTTP GET: ' + url);
    return this.http.get<any>(url);
    /*.pipe(
      tap(response =>
      {
        if (response.participants)
          response.participants.sort((x, y) => (+x.numberOfPlayers) - (+y.numberOfPlayers) || x.displayName.localeCompare(y.displayName));
      }));*/
  }

  copyPerformancesFromEvent(eventSourceId: number, eventTargetId: number): Observable<any[]>
  {
    const filter = new URLSearchParams([
      ['eventSourceId', eventSourceId + ''],
      ['eventTargetId', eventTargetId + '']
    ]);

    const url = this.sessionService.baseUrlApi + 'performance/copy?' + filter.toString();
    console.log('HTTP POST: ' + url);
    return this.http.post<any[]>(url, undefined);
  }

}
